/**
* Created by Omar Alejandro Leonor Avalos on 2017-06-06.
* Item model for each "despacho"
*/
import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';
import Adjuntar from 'material-ui/svg-icons/editor/attach-file';
import Edit from 'material-ui/svg-icons/content/create';
import Trash from 'material-ui/svg-icons/action/delete';
import Block from 'material-ui/svg-icons/content/block';
import Guardar from 'material-ui/svg-icons/content/save';
import { EditableInline, EditableInlineV2 } from '../../../components/text';
import IconButton from 'material-ui/IconButton';
import AutoComplete from 'material-ui/AutoComplete';
import { setValueIn } from '../../../common/immutable';
import { parsePath, getValueFromSelectList } from '../../../common/helpers';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import ActionFavorite from 'material-ui/svg-icons/action/favorite';
import ActionFavoriteBorder from 'material-ui/svg-icons/action/favorite-border';
import { buildErrorsState, validateField, errorsEmpty } from '../../../validations';
import * as actionsToAddFile from '../actions';
import RaisedButton from 'material-ui/RaisedButton';
import { Dialog, LinearProgress, CircularProgress } from 'material-ui';

import moment from 'moment';
import {
    preInvoice as preInvoice
} from '../../../services';


const styles = {
    block: {
        maxWidth: 250,
    },
    radioButton: {
        marginBottom: 5,
        marginLeft: 10,
    },
};

var Aux = [];
//Fields goes here, it might corresponds with the names of the props
//you modify on state
const errorsProps = {
    customer: [],
    supplier: [],
    statusColor: [],
    status: [],
    folio: [],
    customsHouse: [],
    requestingPaymentTimestamp: [],
    arrivalTimestamp: [],
    requestingNumber: [],
    via: [],
    comertialInvoiceNumber: [],
    shippingCompany: [],
    packages: [],
    weight: [],
    folioPrefix: [],
    folioYear: []
};

var rules = {};

//Each rule might correspond with the key for the field to validate
//For now I only use comertialInvoiceNumber


class Item extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            customsClearenceState: props.customsClearenceProps,
            errors: { ...errorsProps },
            completed: 0,
            OpenLoad: false,
            OpenError: false,
            OpenErrorClosed: false,
            MessageLoad: '',
            showMessageLoad: false,
            filesInExist: [],
            FilestoLoadName: []
        };
    }

    progress(completed) {
        if (completed > 100) {
            this.setState({ completed: 0 });
            this.setState({ showMessageLoad: true })
            clearTimeout(this.timer);
        } else {
            this.setState({ completed });
            const diff = Math.random() * 35;
            this.timer = setTimeout(() => this.progress(completed + diff), 1000);
        }
    }
    updateCustomsClearence(path, value) {
        //Recalculate errors
        const errors = Object.assign(
            {},
            this.state.errors,
            validateField(rules, path, value)
        );

        const customsClearenceState = setValueIn(parsePath(path), value, this.state.customsClearenceState);
        this.setState({ customsClearenceState, errors });
    }

    renderButtons(editing, customsClearenceState, onSave) {
        const { allowUpdate, allowDelete, allowOnlyToModifyRequestPayment } = this.props;

        return (
            <div className="space-around">
                {
                    editing && <IconButton
                        tooltip="Cancelar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => this.setState({ editing: false, customsClearenceState, errors: errorsProps })}
                    >
                        <Block />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    editing && <IconButton
                        tooltip="Guardar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            if (errorsEmpty(this.state.errors)) {
                                this.setState({ editing: false });
                                onSave(this.state.customsClearenceState);
                            }
                        }}
                    >
                        <Guardar />
                    </IconButton>
                }
                {editing && <div className="vertical-line" />}
                {
                    (!editing && (allowUpdate || allowOnlyToModifyRequestPayment)) &&
                    <IconButton
                        tooltip="Editar"
                        iconStyle={{ color: '#FFF' }}
                        onTouchTap={() => {
                            this.setState({ customsClearenceState: customsClearenceState })
                            this.setState({ editing: true });
                            this.setState({ customsClearenceState: customsClearenceState })
                        }}
                    >
                        <Edit />
                    </IconButton>
                }
            </div>
        );
    }

    pad(num, size) {
        var s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    renderEstados(status, statuses, customsClearenceState, onSave) {
        var statusArray = [{ "name": "number0" }];

        if (statuses.length != null || statuses.length != undefined) {
            statusArray = statuses;
        }

        var statusArray = statuses.filter(function (statuses) { return statuses.statusName != "CERRADO"; });

        return (
            <RadioButtonGroup
                name="shipSpeed"
                defaultSelected={status}
                onChange={this._onChange.bind(this)}
            >
                {
                    statusArray.map((obj, index) =>
                        <RadioButton
                            value={obj.statusName}
                            label={obj.representation}
                            style={styles.radioButton}
                            key={index}
                        />
                    )
                }
            </RadioButtonGroup>
        );

    }

    renderAttachtButton(customsClearenceState) {
        const { allowAttachments } = this.props;
        if (!allowAttachments) { return null; }
        return (
            <RaisedButton
                icon={<Adjuntar />}
                className="card-buttons"
                containerElement="label"
                style={{ display: 'inline' }}
                labelStyle={{ fontSize: '1.3em', lineHeight: '2.3em' }}
                overlayStyle={{ backgroundColor: '#003d6d', outline: 'none' }}
            >
                <input
                    id="file-input"
                    type="file"
                    multiple
                    style={{ display: 'none' }}
                    onChange={(event) => {
                        this.handleChange(event, 'file', event.target.files)

                    }}
                    onClick={(event) => {
                        event.target.value = null
                    }}
                />
            </RaisedButton>
        );
    }

    _onChange(e, selected) {

        var arrayToUpdate = this.props.customsClearenceProps;
        var OriginalStatus = arrayToUpdate.status;

        var count = 0;
        for (var x in arrayToUpdate) {
            if (arrayToUpdate[x] === null || arrayToUpdate[x] === undefined || arrayToUpdate[x] === "") {
                count++;
            }
        }

        if (OriginalStatus.toLowerCase().includes("CERRADO".toLowerCase()) && selected.toLowerCase() != OriginalStatus.toLowerCase()) {
            this.setState({ OpenErrorClosed: true });
            arrayToUpdate.status = OriginalStatus;
        } else {
            arrayToUpdate.status = selected;
            this.props.onSave(arrayToUpdate);
        }

        /*if (selected != OriginalStatus) {
            arrayToUpdate.status = selected;
            this.props.onSave(arrayToUpdate);
        }*/
    }

    CheckCustomClearanceFields() {

        preInvoice.getAttachedFiles({
            folio: this.props.customsClearenceProps.folio
        }).then(data => {

            var arrayToUpdate = this.props.customsClearenceProps;
            var count = 0;


            for (var x in arrayToUpdate) {
                if (x == "invoicingTime" || x == "user" || x == "comments") {

                } else {
                    if (arrayToUpdate[x] === null || arrayToUpdate[x] === undefined || arrayToUpdate[x] === "") {
                        count++;
                    }
                }
            }

            if (count != 0) {
                this.setState({ OpenError: true });
            } else {
                if (data.data.length != 0) {
                    this.props.onOpenPrefacturaModal();
                } else {
                    this.setState({ OpenError: true });
                }
            }
        })
    }


     checkFileSize(inputFile) {
      var max = 5 * 1024 * 1024; // 5B


      if (inputFile.file && inputFile.file[0].size > max) {
          inputFile.value = null; // Clear the field.
          return true;
      }
    }

    handleChange(event, key, value) {
        const form = { [key]: value };
        preInvoice.getAttachedFiles({
            folio: this.props.customsClearenceProps.folio
        }).then(data => {

            var FilestoLoad = { file: [] };
            var FilestoLoadName = [];
            var FilesAttached = [];

            for (var i = 0; i < form.file.length; i++) {
                if (data.data.indexOf(form.file[i].name) < 0) {
                    FilestoLoad.file.push(form.file[i]);
                    FilestoLoadName.push(form.file[i].name);
                } else {
                    FilesAttached.push(form.file[i].name);
                }
            }

            if (FilestoLoad.file.length > 0 ) {
                actionsToAddFile.GuardarArchivosAdjuntos(this.props.customsClearenceProps, FilestoLoad).then(response => {

                    if (response != "" || response != undefined || response != null) {

                      if( typeof(response.response) === "undefined"){
                        if (FilestoLoad.file.length == 1) {
                            this.timer = setTimeout(() => this.progress(40), 1000);
                        } else {
                            this.timer = setTimeout(() => this.progress(20), 1000);
                        }

                        if (FilesAttached.length > 0) {
                            this.setState({ filesInExist: FilesAttached });
                        }
                        this.setState({ MessageLoad: response });
                        this.setState({ FilestoLoadName: FilestoLoadName });
                        this.setState({ OpenLoad: true });
                      }else {
                        if(this.checkFileSize(FilestoLoad)){
                          this.props.actions.updateSnackBar("El archivo que intentas subir es mayor a 5 MegaBytes");
                        }else{
                          this.props.actions.updateSnackBar(response.response.data.message);
                        }
                      }
                    }
                });
            } else {
                if (FilesAttached.length > 0) {
                    this.setState({ OpenLoad: true });
                    this.setState({ filesInExist: FilesAttached });
                    this.setState({ showMessageLoad: true });
                    this.setState({ MessageLoad: "Por favor selecciona otros archivos" });
                }
            }
        })

    }

    render() {
        const { editing, errors } = this.state;
        const { customsClearenceProps, onOpenInfoModal, onOpenPrefacturaModal, onSave, customsHouses, customers, suppliers, actions, statuses = [], allowOnlyToModifyRequestPayment, allowPreinvoice, allowUpdate } = this.props;

        const currentProperties = editing ? this.state.customsClearenceState : customsClearenceProps;
        const { customer, supplier, statusColor, status, folio, customsHouse, requestingPaymentTimestamp, arrivalTimestamp,
            requestingNumber, via, comertialInvoiceNumber, shippingCompany, packages, weight, folioPrefix, folioYear, type, attachedFiles } = currentProperties;

            const selectedCustomsHouse = this.props.customsHouses.items.find(ch => ch.uuid === this.props.customsClearenceProps.customsHouse.id);
            const requireRequestingNumber = selectedCustomsHouse && selectedCustomsHouse.ownOffice;
            const requestingNumberBasicRule = { key: 'validationMask', errorText: 'Por favor debe ser tipo XXXX-YYYYYYY' };
            const requestingNumberRules = requireRequestingNumber ?
                [requestingNumberBasicRule, { key: 'required', errorText: 'Campo Requerido' }] : [requestingNumberBasicRule];


            const rulesAux = {
                customer: [{ key: 'required', errorText: 'Por favor, seleccione el cliente' }],
                supplier: [{ key: 'required', errorText: 'Por favor, seleccione al proveedor' }],
                arrivalTimestamp: [{ key: 'required', errorText: 'Por favor, seleccione la fecha de arribo' }],
                customsHouse: [{ key: 'required', errorText: 'Campo requerido' }],
                shippingCompany: [{ key: 'required', errorText: 'Campo requerido' }],
                packages: [
                    { key: 'required', errorText: 'Campo requerido' },
                    { key: 'packagesRules', errorText: 'Indique el numero seguido de Concepto' }
                ],
                requestingNumber: requestingNumberRules,
                weight: [
                    { key: 'required', errorText: 'Campo requerido' },
                    { key: 'numberWithDecimals', errorText: 'Numero invalido' }
                ]
            };

            rules = rulesAux;

        const actionsDialog = [
            <FlatButton
                label="Aceptar"
                primary={true}
                disabled={!this.state.showMessageLoad}
                keyboardFocused={true}
                onClick={() => {
                    this.setState({ OpenLoad: false });
                    this.setState({ MessageLoad: "" });
                    this.setState({ showMessageLoad: false });
                    this.setState({ filesInExist: [] });
                    this.setState({ FilestoLoadName: [] });
                }}
            />,
        ];

        return (
            <div className="col-md-12 main-card item-row" key={customsClearenceProps.folio}>
                <div className="row">
                    <div className={`col-lg-2 col-md-3 col-sm-5 col-xs-12 card-status display-flex-center dropdown`} style={{ minHeight: '3.6rem', background: statusColor }}>
                        <button className="btn btn-empty w-100-i dropdown-toggle" style={{ padding: '1rem 0rem' }} type="button" data-toggle="dropdown">
                            <h3>{status}</h3>
                        </button>
                        {
                            allowUpdate &&
                            <ul className="dropdown-menu no-borders">
                                {this.renderEstados(status, statuses, customsClearenceProps, onSave)}
                            </ul>
                        }
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6 card-id " style={{ cursor: 'pointer' }} onClick={onOpenInfoModal}>
                        <div className="col-sm-12 display-flex-center" style={{ minHeight: '3.6rem' }}>
                            <h3 key={folio}>{folioPrefix}{folioYear}{this.pad(folio, 5)}</h3>
                        </div>
                    </div>
                    <div
                        className="col-lg-4 col-md-2 col-sm-3 col-xs-6 card-id"
                        style={{ cursor: 'pointer' }}
                        onClick={() => { allowPreinvoice && this.CheckCustomClearanceFields() }}
                    >
                        <div
                            className="col-sm-12 display-flex-center no-paddings"
                            style={{ minHeight: '3.6rem', justifyContent: 'flex-end' }}
                        >
                            {allowPreinvoice && <h3>Generar Prefactura</h3>}
                        </div>
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-1 col-xs-12 card-id card-buttons text-center" style={{ background: '#003d6d', minHeight: '3.6rem', zIndex: 0 }}>
                        {this.renderAttachtButton(customsClearenceProps)}
                    </div>
                    <div className="col-lg-2 col-md-3 col-sm-6 col-xs-12 card-buttons hidden-md-down" style={{ minHeight: '3.6rem', paddingTop: '0.8rem' }}>
                        {this.renderButtons(editing, customsClearenceProps, onSave)}
                    </div>
                </div>
                <div className="row white-card padding-2">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                <p className="text-bold text-color-light">Cliente Asignado</p>
                                <EditableInlineV2
                                    type="remoteAutocomplete"
                                    editViewActive={editing && allowUpdate}
                                    value={customer.name}
                                    serviceName='customers'
                                    entity='customers'
                                    url='/customers/search/findTop10ByNameIgnoreCaseContaining'
                                    onAdd={actions.onAddClient}
                                    projectionName='forListing'
                                    notify={(value) => {
                                        this.updateCustomsClearence('customer', value);
                                    }}

                                />
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                <p className="text-bold text-color-light">Proveedor Asignado</p>
                                <EditableInlineV2
                                    type="remoteAutocomplete"
                                    editViewActive={editing && allowUpdate}
                                    value={supplier.name}
                                    serviceName='suppliers'
                                    entity='suppliers'
                                    url='/suppliers/search/findTop10ByNameIgnoreCaseContaining'
                                    onAdd={actions.onAddSupplier}
                                    projectionName='forListing'
                                    notify={(value) => this.updateCustomsClearence('supplier', value)}
                                />
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                <p className="text-bold text-color-light">Aduana de Despacho</p>
                                <EditableInlineV2
                                    type="autocomplete"
                                    editViewActive={editing && allowUpdate}
                                    items={customsHouses.items}
                                    value={getValueFromSelectList(customsHouses.items, customsHouse.name).name}
                                    notify={(value) => {
                                        this.updateCustomsClearence('customsHouse>id', value.uuid);
                                        this.updateCustomsClearence('customsHouse>name', value.id);
                                    }}
                                />
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                <EditableInlineV2
                                    type="date"
                                    label="Pago del pedimento"
                                    value={requestingPaymentTimestamp}
                                    editViewActive={editing && (allowOnlyToModifyRequestPayment || allowUpdate)}
                                    notify={(value) => this.updateCustomsClearence('requestingPaymentTimestamp', value)}
                                />
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                <EditableInlineV2
                                    type="date"
                                    value={arrivalTimestamp}
                                    label={type === "EXPORT" ? "Fecha salida" : "Fecha arribo"}
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('arrivalTimestamp', value)}
                                />
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                <EditableInlineV2
                                    type="text"
                                    value={requestingNumber}
                                    label="Número de pedimento"
                                    editViewActive={editing && allowUpdate && !customsHouse.ownOffice}
                                    notify={(value) => this.updateCustomsClearence('requestingNumber', value)}
                                    errorText={errors.requestingNumber.join(' | ')}
                                />
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                <EditableInlineV2
                                    type="autocomplete"
                                    value={getValueFromSelectList([
                                        { id: 'Terrestre', name: 'Terrestre' },
                                        { id: 'Maritima', name: 'Maritima' },
                                        { id: 'Aerea', name: 'Aerea' }
                                    ], via).name}
                                    label="Vía"
                                    editViewActive={editing && allowUpdate}
                                    items={[
                                        { id: 'Terrestre', name: 'Terrestre' },
                                        { id: 'Maritima', name: 'Maritima' },
                                        { id: 'Aerea', name: 'Aerea' }
                                    ]}
                                    notify={(value) => this.updateCustomsClearence('via', value.id)}
                                />
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                {/*Send the error text prop like this for all fields*/}
                                <EditableInlineV2
                                    type="text"
                                    value={comertialInvoiceNumber}
                                    label="Número de factura comercial"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('comertialInvoiceNumber', value)}
                                />
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                <EditableInlineV2
                                    type="text"
                                    value={shippingCompany}
                                    label="Aerolinea / Naviera / Carrier"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('shippingCompany', value)}
                                    errorText={errors.shippingCompany.join(' | ')}
                                />
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                <EditableInlineV2
                                    type="text"
                                    value={packages}
                                    label="Bultos"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => {
                                        this.updateCustomsClearence('packages', value)
                                    }}
                                    errorText={errors.packages.join(' | ')}
                                />
                            </div>
                            <div className="col-lg-2 col-md-3 col-sm-3 col-xs-6">
                                <EditableInlineV2
                                    type="text"
                                    value={weight}
                                    label="Peso"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('weight', value)}
                                    errorText={errors.weight.join(' | ')}
                                />
                            </div>
                        </div>

                        <Dialog
                            className="modalstyle"
                            open={this.state.OpenLoad}
                            modalInfoOpen
                            actions={actionsDialog}
                            onRequestClose={() => {
                                this.setState({ OpenLoad: false });
                                this.setState({ MessageLoad: "" });
                                this.setState({ showMessageLoad: false });
                                this.setState({ filesInExist: [] });
                                this.setState({ FilestoLoadName: [] });
                            }}
                        >
                            <div className="row">
                                <div><h4>Subiendo Archivos</h4></div>
                                <br />
                                {this.state.filesInExist.length > 0 ? "Estos archivos seleccionados ya existen " + this.state.filesInExist : null}
                                <br />
                                <br />
                                {this.state.showMessageLoad == true ? this.state.MessageLoad : <CircularProgress style={{ marginLeft: '50%' }} size={80} thickness={5} />}
                                <br />
                                <br />
                                {this.state.showMessageLoad == true && this.state.FilestoLoadName.length > 0 ? this.state.FilestoLoadName : null}
                            </div>
                        </Dialog>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-9 col-sm-7 col-xs-6 hidden-lg-up">
                    </div>
                    <div className="col-sm-12 col-md-3 col-sm-5 col-xs-6 card-buttons hidden-lg-up" style={{ minHeight: '3.6rem', paddingTop: '0.8rem' }}>
                        <div className="space-around">
                            {this.renderButtons(editing, customsClearenceProps, onSave)}
                        </div>
                    </div>
                </div>
                <Dialog
                    title="Error"
                    modal={false}
                    open={this.state.OpenError}
                    onRequestClose={() => this.setState({ OpenError: false })}
                >
                    El despacho no tiene capturada la información completa. Por favor asegurece de que el despacho tiene la información completamente capturada

                </Dialog>
                <Dialog
                    title="Error"
                    modal={false}
                    open={this.state.OpenErrorClosed}
                    onRequestClose={() => this.setState({ OpenErrorClosed: false })}
                >
                    El despacho cerrado no puede cambiar de estado

                </Dialog>
            </div>
        );
    }
}

export default Item;



// WEBPACK FOOTER //
// ./containers/despachos/components/item.js